/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker, NumberFilterInput } from 'components/filters';
import {} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
import RequiresRole from 'flaivy-react/components/RequiresRole';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function SupplierFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.supplierNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.currency === 'undefined' && (
          <FormGroup>
            <Label>Valuta</Label>
            <Select
              instanceId="select-currency"
              name="currency"
              value={_.get(resolvedQuery, 'currency', '')}
              onChange={handleChange}
              options={[
                { value: 'SEK', label: 'SEK' },
                { value: 'NOK', label: 'NOK' },
                { value: 'DKK', label: 'DKK' },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.name === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.logo === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.organisationNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'customerSubUnitAdmin',
            'customerSubUnitEconomy',
            'customerSubUnitPurchaserManager',
            'customerSubUnitPurchaserAssociateManager',
            'customerSubUnitPurchaser',
            'customerSubUnit',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.ourReference === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.email === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.emailForPurchaseOrder === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.phone === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.bank === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.bg === 'undefined' && <FormGroup></FormGroup>}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.pg === 'undefined' && <FormGroup></FormGroup>}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.bic === 'undefined' && <FormGroup></FormGroup>}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.iban === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.homepage === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.utilitySupplier === 'undefined' && (
            <FormGroup>
              <Label>Z-markerad</Label>
              <br />
              <ButtonGroup>
                <Button
                  color="secondary"
                  active={_.get(resolvedQuery, 'utilitySupplier') === undefined}
                  onClick={() => {
                    handleChange('utilitySupplier', undefined);
                  }}
                >
                  Alla
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'utilitySupplier') === true ||
                    _.get(resolvedQuery, 'utilitySupplier') === 'true'
                  }
                  onClick={() => {
                    handleChange('utilitySupplier', true);
                  }}
                >
                  Ja
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'utilitySupplier') === false ||
                    _.get(resolvedQuery, 'utilitySupplier') === 'false'
                  }
                  onClick={() => {
                    handleChange('utilitySupplier', false);
                  }}
                >
                  Nej
                </Button>
              </ButtonGroup>
            </FormGroup>
          )}
        </RequiresRole>

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Aktiverad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.invoiceAddress === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.invoiceZipCode === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.invoiceCity === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.invoiceCountry === 'undefined' && (
            <FormGroup>
              <Label>Land</Label>
              <Select
                type="string"
                instanceId="select-invoiceCountry"
                name="invoiceCountry"
                value={_.get(resolvedQuery, 'invoiceCountry')}
                onChange={handleChange}
                options={[
                  { label: 'Sverige', value: 'SE' },
                  { label: 'Finland', value: 'FI' },
                  { label: 'Norge', value: 'NO' },
                  { label: 'Danmark', value: 'DK' },
                  { label: 'Island', value: 'IS' },
                  { label: 'Alla', value: undefined },
                ]}
              />
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.VATNumber === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'super',
            'supplier',
            'qvantiSupplierRoleArticleChanges',
          ]}
        >
          {typeof immutableQuery.GLNNumber === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super', 'supplier']}>
          {typeof immutableQuery.ourCustomerNumber === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super', 'supplier']}>
          {typeof immutableQuery.prognosisOrderCount === 'undefined' && (
            <FormGroup>
              <Label>Prognos antal order per 12 månader</Label>
              <NumberFilterInput
                name="prognosisOrderCount"
                value={_.get(resolvedQuery, 'prognosisOrderCount')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super', 'supplier']}>
          {typeof immutableQuery.prognosisRevenue === 'undefined' && (
            <FormGroup>
              <Label>Prognos omsättning per 12 månader</Label>
              <NumberFilterInput
                name="prognosisRevenue"
                value={_.get(resolvedQuery, 'prognosisRevenue')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super', 'supplier']}>
          {typeof immutableQuery.hasArticlesAtExacta === 'undefined' && (
            <FormGroup>
              <Label>Har artiklar hos Exacta</Label>
              <br />
              <ButtonGroup>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'hasArticlesAtExacta') === undefined
                  }
                  onClick={() => {
                    handleChange('hasArticlesAtExacta', undefined);
                  }}
                >
                  Alla
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'hasArticlesAtExacta') === true ||
                    _.get(resolvedQuery, 'hasArticlesAtExacta') === 'true'
                  }
                  onClick={() => {
                    handleChange('hasArticlesAtExacta', true);
                  }}
                >
                  Ja
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'hasArticlesAtExacta') === false ||
                    _.get(resolvedQuery, 'hasArticlesAtExacta') === 'false'
                  }
                  onClick={() => {
                    handleChange('hasArticlesAtExacta', false);
                  }}
                >
                  Nej
                </Button>
              </ButtonGroup>
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super', 'supplier']}>
          {typeof immutableQuery.preDefinedAccount === 'undefined' && (
            <FormGroup>
              <Label>Fördefinierat Konto</Label>
              <Select
                type="string"
                instanceId="select-preDefinedAccount"
                name="preDefinedAccount"
                value={_.get(resolvedQuery, 'preDefinedAccount')}
                onChange={handleChange}
                options={[
                  { label: '4000 - Inköp övriga varor 25%', value: '4000' },
                  { label: '4004 - Inköp Livsmedel LG (12%)', value: '4004' },
                  { label: '4005 - Inköp Livsmedel KM (12%)', value: '4005' },
                  {
                    label: '4010 - Inköp Alkoholhaltiga varor LG (25%)',
                    value: '4010',
                  },
                  {
                    label: '4011 - Inköp Alkoholhaltiga varor KM (25%)',
                    value: '4011',
                  },
                  {
                    label: '4014 - Inköp Alkoholfritt LG (12%)',
                    value: '4014',
                  },
                  { label: '4017 - Inköp Alkoholfritt KM 12%', value: '4017' },
                  { label: 'Alla', value: undefined },
                ]}
              />
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super', 'supplier']}>
          {typeof immutableQuery.exciseNumberAtVinden === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        {typeof immutableQuery.owningSupplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.hasPublishedArticles === 'undefined' && (
          <FormGroup>
            <Label>Har denna leverantör publicerade artiklar?</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasPublishedArticles') === undefined
                }
                onClick={() => {
                  handleChange('hasPublishedArticles', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasPublishedArticles') === true ||
                  _.get(resolvedQuery, 'hasPublishedArticles') === 'true'
                }
                onClick={() => {
                  handleChange('hasPublishedArticles', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasPublishedArticles') === false ||
                  _.get(resolvedQuery, 'hasPublishedArticles') === 'false'
                }
                onClick={() => {
                  handleChange('hasPublishedArticles', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

SupplierFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

SupplierFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function SupplierFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <SupplierFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

SupplierFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

SupplierFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { SupplierFilterPanel, SupplierFilterPanelModal };
